const countdownElement = document.querySelector('.announcement-slider__countdown');
if (countdownElement) {
  const dateString = countdownElement.getAttribute('data-deadline');
  const countdownIndex = countdownElement.getAttribute('data-index');
  const deadline = document.querySelector('.announcement-slider__deadline');
  const [datePart, timePart] = dateString.split(' ');
  const [d, m, y] = datePart?.split(/-|\//);
  const [hours, minutes, seconds] = timePart?.split(':');
  const futureDate = new Date(y, m - 1, d, hours, minutes, seconds);
  function updateCountdown() {
    const currentDate = new Date();
    const timeDifference = futureDate - currentDate; // Difference in milliseconds

    if (timeDifference > 0) {
      // Convert to milliseconds, seconds, minutes, hours, days
      const seconds = Math.floor(timeDifference / 1000 % 60);
      const minutes = Math.floor(timeDifference / (1000 * 60) % 60);
      const hours = Math.floor(timeDifference / (1000 * 60 * 60) % 24);
      const days = Math.floor(timeDifference / (1000 * 60 * 60 * 24));
      let timeParts = '';
      if (days > 0) timeParts += `${days}${countdownElement.getAttribute('data-countdown-day')}`;
      if (hours > 0) timeParts += ` ${hours}${countdownElement.getAttribute('data-countdown-hour')}`;
      if (minutes > 0) timeParts += ` ${minutes}${countdownElement.getAttribute('data-countdown-minute')}`;
      if (seconds > 0) timeParts += ` ${seconds}${countdownElement.getAttribute('data-countdown-second')}`;

      // Join the parts
      const result = timeParts;
      deadline.textContent = `${result}`;
    } else {
      countdownElement.remove();
      clearInterval(interval); // Stop the interval when the countdown is over
    }
  }

  // Update the countdown every second
  const interval = setInterval(updateCountdown, 1000);
}